export const chartBarOptions = {
  chart: {
    height: 300,
    type: 'bar',
    zoom: {
      enabled: false,
    },
  },

  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
    width: 2,
  },
  title: {
    text: '',
    align: 'center',
  },
  // grid: {
  //     row: {
  //         colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
  //         opacity: 0.5
  //     },
  // },
  xaxis: {
    categories: ['1', '2', '3', '4', '5', '6', '7', '8'],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
  },
  markers: {
    size: 5,
  },
  colors: ['#0098da', '#ec7d31'],
  // annotations: {
  //     yaxis: [
  //         {
  //             y: 50,
  //             y2: 100,
  //             borderColor: '',
  //             fillColor: '#9dc8e1',
  //             label: {
  //                 text: ''
  //             }
  //         },
  //         {
  //             y: 0,
  //             y2: 49,
  //             borderColor: '',
  //             fillColor: '#ffcccc',
  //             label: {
  //                 text: ''
  //             }
  //         }
  //     ]
  // },
  // colors: ['#008FFB', '#ff9933']
}

export const chartRadialOptionsDefinitivo = {
  chart: {
    height: 350,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      offsetY: -25,
      hollow: {
        size: '50%',
      },
      track: {
        background: '#fff',
        strokeWidth: '67%',
        margin: 0, // margin is in pixels
        dropShadow: {
          enabled: true,
          top: -3,
          left: 0,
          blur: 4,
          opacity: 0.35,
        },
      },
      dataLabels: {
        showOn: 'always',
        name: {
          show: true,
          offsetY: -15,
        },

        value: {
          /*   color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: -5,
          formatter: function (val) {
            const valor = (val / 10).toFixed(2)
            return valor
          },
        },
      },
    },
  },
  /* stroke: {
    lineCap: 'round'
  }, */
  colors: ['#0098da'],
}
export const chartRadialOptionsPrevisao = {
  chart: {
    height: 350,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },
      track: {
        background: '#fff',
        strokeWidth: '67%',
        margin: 0, // margin is in pixels
        dropShadow: {
          enabled: true,
          top: -3,
          left: 0,
          blur: 4,
          opacity: 0.35,
        },
      },
      dataLabels: {
        showOn: 'always',
        name: {
          show: true,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: -5,
          formatter: function (val) {
            const valor = (val / 10).toFixed(2)
            return valor
          },
        },
      },
    },
  },
  /*  stroke: {
    lineCap: 'round'
  }, */
  colors: ['#ef9050'],
}

export const infoHtml = `
<div id='write'  class=''><h4 id='resultado-isf'><strong><span>RESULTADO ISF</span></strong></h4><hr /><p><span>O </span><strong><span>Indicador Sintético Final (ISF)</span></strong><span> representa uma síntese do desempenho municipal nos indicadores que varia de (0) zero a (10) dez, sendo obtido a partir da atribuição da nota individual para cada indicador ponderada pelos pesos de cada indicador.</span></p><p><span>Os Indicadores de Pagamento por Desempenho do Programa Previne Brasil (2022) estão tratados na </span><a href='https://www.in.gov.br/en/web/dou/-/portaria-gm/ms-n-102-de-20-de-janeiro-de-2022-375495336' target="_blank"><span>Portaria GM/MS nº 102, de 20 de janeiro de 2022</span></a><span>, que alterou a </span><a href='https://www.in.gov.br/en/web/dou/-/portaria-n-3.222-de-10-de-dezembro-de-2019-232670481' target="_blank"><span>Portaria GM/MS nº 3.222, de 10 de dezembro de 2019</span></a><span>, que dispõe sobre os indicadores do pagamento por desempenho, no âmbito do Programa Previne Brasil.</span> <span>A </span><strong><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_12.pdf' target="_blank"><span>Nota Técnica 12/2022</span></a></strong><span> - Indicadores de Pagamento por Desempenho do Programa Previne Brasil (2022) refere-se a </span><a href='https://www.in.gov.br/en/web/dou/-/portaria-gm/ms-n-102-de-20-de-janeiro-de-2022-375495336' target="_blank"><span>Portaria GM/MS nº 102, de 20 de janeiro de 2022</span></a><span>, que alterou a </span><a href='https://www.in.gov.br/en/web/dou/-/portaria-n-3.222-de-10-de-dezembro-de-2019-232670481' target="_blank"><span>Portaria GM/MS nº 3.222, de 10 de dezembro de 2019</span></a><span>, que dispõe sobre os indicadores do pagamento por desempenho, no âmbito do Programa Previne Brasil.</span></p><p><span>O resultado dos indicadores é liberado ao final de cada quadrimestre (janeiro, maio e setembro) no site do </span><a href='https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml' target="_blank"><span>SISAB</span></a><span>. O ISF pode ser conferido no </span><a href='https://sisaps.saude.gov.br/painelsaps/isf' target="_blank"><span>Painel de Indicadores</span></a><span> do e-GESTOR, quando disponibilizado.  </span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Se o resultado, aqui apresentado, entre </span><strong><span>Previsão</span></strong><span> e </span><strong><span>Definitivo</span></strong><span> estiverem diferentes, analisando-se o mesmo quadrimestre (mês 4 = Q1, mês 8 = Q2 e mês 12 = Q3), então é importante verificar se ocorreu reprovação de dados no SISAB. Essa verificação pode ser feita com acesso restrito no </span><a href='https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/envio/RelValidacao.xhtml' target="_blank"><span>Relatório de Validação</span></a><span> considerando os quatro meses que compõe o quadrimestre avaliado. </span></p><p><strong><span>Pode existir diferença de dados entre o e-SUS PEC ou Centralizador e o SISAB, pois para chegar no SISAB os dados passam por uma validação. Para mais informações, recomenda-se a leitura da</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/esus/relatorio_validacao_2_2021_nota.pdf' target="_blank"><strong><span>Nota Técnica</span></strong></a><span> </span><strong><span>que explica em detalhes o processo de validação.</span></strong></p><p><span>Basicamente, a reprovação de dados no SISAB acontece por divergência entre as lotações dos profissionais de saúde no e-SUS PEC ou Centralizador e o cadastro no CNES. Para evitar essas reprovações, recomenda-se ao Administrador municipal do e-SUS, pelo menos uma vez por semana, aqui no sistema ir em </span><strong><span>INÍCIO &gt;&gt; Profissionais PEC CNES</span></strong><span>, esperar os dados carregar e verificar se tem divergências, as quais podem ser comunicadas ao Administrador do CNES para fazer as devidas adequações. </span></p><p><span>É sempre recomendado, pelo menos uma vez por mês, importar o XML gerado pelo SISAB no sistema e-SUS PEC ou Centralizador para manter as lotações dos profissionais de saúde sempre atualizadas.</span></p></blockquote><p>&nbsp;</p><h4 id='funcionalidades'><strong><span>FUNCIONALIDADES</span></strong></h4><hr /><p><span>Esta tela mostra a possibilidade de filtrar por </span><strong><span>Previsão</span></strong><span> (cálculo com base nos dados locais do e-SUS PEC ou Centralizador) ou </span><strong><span>Definitivo</span></strong><span> (resultado liberado no SISAB). Os dados com base nos filtros escolhidos podem ser visualizados na tabela de dados, gráfico de barras e gráfico de rosca.</span></p><p>&nbsp;</p><p><strong><span>Filtro previsão e definitivo</span></strong></p><p><span>No filtro </span><strong><code>Previsão</code></strong><span>, você pode escolher um determinado mês para visualizar os dados. Já no filtro </span><strong><code>Definitivo</code></strong><span>, você pode escolher um quadrimestre. </span></p><p><span>Para </span><strong><span>comparar a previsão e o resultado definitivo</span></strong><span> em determinado quadrimestre, na previsão deve-se escolher o mês final de cada quadrimestre (mês 4 = Q1, mês 8 = Q2 e mês 12 = Q3).</span></p><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A tabela de dados mostra os resultados (Definitivo e Previsão) dos indicadores a nível municipal. Ao passar o mouse sobre o nome da coluna da tabela, será mostrado o nome completo do indicador e sua legenda.</span></p><ul><li><p><strong><span>Indicador 1 (I1) – Pré-Natal</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_13.pdf' target="_blank"><strong><span>Nota Técnica 13/2022</span></strong></a><span> - Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a 1ª até a 12 ª semana de gestação;</span></p></li><li><p><strong><span>Indicador 2 (I2) – Sífilis e HIV</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_14.pdf' target="_blank"><strong><span>Nota Técnica 14/2022</span></strong></a><span> - Proporção de gestantes com realização de exames para sífilis e HIV;</span></p></li><li><p><strong><span>Indicador 3 (I3) – Pré-Natal Odontológico (PNO)</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_15.pdf' target="_blank"><strong><span>Nota Técnica 15/2022</span></strong></a><span> - Proporção de gestantes com atendimento odontológico realizado na Atenção Primária à Saúde;</span></p></li><li><p><strong><span>Indicador 4 (I4) – Citopatológico</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_16.pdf' target="_blank"><strong><span>Nota Técnica 16/2022</span></strong></a><span> - Proporção de mulheres com coleta de citopatológico na Atenção Primária à Saúde;</span></p></li><li><p><strong><span>Indicador 5 (I5) - Imunização</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_22.pdf' target="_blank"><strong><span>Nota Técnica 22/2022</span></strong></a><span> - Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas por </span><em><span>haemophilus influenzae</span></em><span> tipo b e Poliomielite inativada;</span></p></li><li><p><strong><span>Indicador 6 (I6) – Hipertensão Arterial Sistêmica (HAS)</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_18.pdf' target="_blank"><strong><span>Nota Técnica 18/2022</span></strong></a><span> - Proporção de pessoas com hipertensão, com consulta e pressão arterial aferida no semestre;</span></p></li><li><p><strong><span>Indicador 7 (I7) – Diabetes (DM)</span></strong><span> </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_23.pdf' target="_blank"><strong><span>Nota Técnica 23/2022</span></strong></a><span> - Proporção de pessoas com diabetes, com consulta e hemoglobina glicada solicitada no semestre;</span></p></li><li><p><strong><span>ISF</span></strong><span> - resultado do Indicador Sintético Final;</span></p></li><li><p><strong><span>QUADRIMESTRE</span></strong><span> - quadrimestre que pertence o resultado;</span></p></li><li><p><strong><span>FONTE</span></strong><span> - SISAB (resultado definitivo) e e-SUS PEC (resultado preliminar).</span></p></li></ul><p>&nbsp;</p><p><strong><span>Gráficos</span></strong></p><p><span>O </span><strong><span>gráfico de barras verticais</span></strong><span> mostra o resultado (Definitivo e Previsão) por indicador. O </span><strong><span>gráfico de rosca</span></strong><span> mostra o resultado ISF (Definitivo e Previsão).</span></p></div>
`
